/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PersonDropdown_persons = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly fullName: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profilePictureId: string | null;
        readonly active: boolean | null;
        readonly client: {
            readonly id: string;
        } | null;
        readonly role: {
            readonly name: string | null;
        } | null;
    } | null;
    readonly " $refType": "PersonDropdown_persons";
}>;
export type PersonDropdown_persons$data = PersonDropdown_persons;
export type PersonDropdown_persons$key = ReadonlyArray<{
    readonly " $data"?: PersonDropdown_persons$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PersonDropdown_persons">;
}>;



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PersonDropdown_persons",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PersonTypeEdge"
};
})();
(node as any).hash = '723979b9af200f390d1737244100e6ac';
export default node;
